module.exports = __webpack_public_path__ + "banquet/components/images/tag_delete.ce22f5ecb394ee744337be186254c678.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/tag_delete.png
// module id = 1710
// module chunks = 1